import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.cat-cards';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      if (!query.data) return;

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        if (query.classList.contains('grid')) {
          query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
            <div class="cat-card">
              ${item.icon ? `<div class="image-wrapper">
                <img src="${item.icon}" alt="${item.title}">
              </div>` : ''}
              ${item.title ? `<h3 class="title">${item.title}</h3>` : ''}
              ${item.text ? `<p class="description">${item.text}</p>` : ''}
              ${item.button_text ? `<p class="btn-custom primary">${item.button_text}</p>` : ''}
            </div>
          `);
        } else {
          query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ ` 
          ${item.button_link ? `<a href="${item.button_link}" class="splide__slide">` : '<div class="splide__slide">'}
            <div class="cat-card">
              ${item.icon ? `<div class="image-wrapper">
                <img src="${item.icon}" alt="${item.title}">
              </div>` : ''}
              ${item.title ? `<h3 class="title">${item.title}</h3>` : ''}
              ${item.text ? `<p class="description">${item.text}</p>` : ''}
              ${item.button_text ? `<p class="btn-custom primary">${item.button_text}</p>` : ''}
            </div>
          ${item.button_link ? '</a>' : '</div>'}
        `);
        }
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
(() => {
  const grid = document.querySelector(`${moduleSelector}.grid`);
  if (grid) return;

  document.querySelectorAll(`${moduleSelector} .splide`).forEach((item) => {
    const moreThanFour = item.querySelectorAll('.splide__slide').length > 4;
    const doubleCard = item.classList.contains('double-cards');
    const slider = new Splide(item, {
      type: 'slide',
      rewind: true,
      perPage: doubleCard ? 2 : 4,
      perMove: 1,
      gap: 20,
      pagination: true,
      drag: moreThanFour || doubleCard,
      arrows: false,
      autoplay: true,
      breakpoints: {
        991: {
          drag: true,
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
